/* eslint-disable no-unused-expressions,object-curly-newline,no-unused-vars */
/* global G */
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread } from 'lib/util'
import applyAdminFilters from 'app/_shared/action/partial/applyAdminFilters'
import swapListSerialAndName from 'app/_shared/action/partial/swapListSerialAndName'

/**
 * ServiceItem Action Index
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  swapListSerialAndName(module),
  applyAdminFilters('list')(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
